import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export const ProgressBar = ({progress, text}) => {

    return(
        <Box sx={{width: '90%', margin: '0 auto', zIndex: '10'}}>
            <LinearProgress  variant="determinate" value={progress} sx={{
                backgroundColor: '#f1f1f1',
                '& .MuiLinearProgress-bar': {
                    backgroundColor: '#044448'
                },
                borderRadius: '10px',
                height: '7px'
            }}/>

            <div className='row justify-content-between px-2'>
                <div className='col  show-info-title px-2 mt-2' style={{"fontSize" : "0.8rem"}}>{text}</div>
                <div className='col-3 text-start  show-info-title mt-2'>{progress}%</div>
            </div>
        </Box>
    )

}
